import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, firstValueFrom, filter } from 'rxjs';
import axios from 'axios';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { UserSource } from 'src/types';

type UpdateUserParams = {
  name: string;
};

export type User = {
  email: string;
  has_2fa: boolean;
  id: string;
  name: string | null;
  email_verified: boolean;
  origin: UserSource;
  created_at: string;
  intercom_hash: string;
};

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private authService = inject(AuthService);
  readonly userSubject = new BehaviorSubject<User | null>(null);

  constructor() {
    this.authService.loggedOut$
      .subscribe(() => {
        this.userSubject.next(null);
      });
  }

  async getUser(): Promise<User> {
    return await firstValueFrom(this.userSubject.pipe(
      filter((user): user is User => !!user),
    ));
  }

  async updateUser(params: UpdateUserParams): Promise<User> {
    const url = environment.baseUrl + `/api/user`;
    const response = await axios.patch<User>(url, params);
    return response.data;
  }

  async setUser(): Promise<User> {
    const url = environment.baseUrl + `/api/user`;
    const result = await axios.get<User>(url);
    this.authService.setOrigin(result.data.origin);
    this.userSubject.next(result.data);
    return result.data;
  }
}
